import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import EventBus from "@/uitls/EventBus";
import { nativeToNewWeb, toLocationBrowser, toMsgChat } from "@/uitls/native";
import IMUtils from "@/network/socket/imUtils";


const __default__ = {
  name: "BannerSwiper",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  items: {
    type: Array,
    default: () => [],
  },
  width: {
    type: Number,
    default: undefined,
  },
  height: {
    type: Number,
    default: undefined,
  },
  autoplay: {
    type: Number,
    default: 4000,
  },
  imageField: {
    type: String,
    default: "cover",
  },
  fallbackImageField: {
    type: String,
    default: "",
  },
  titleField: {
    type: String,
    default: "title",
  },
  imageFit: {
    type: String,
    default: "fill",
  },
  boxPadding: {
    type: String,
    default: "0",
  },
  borderRadius: {
    type: String,
    default: "0",
  },
  backgroundColor: {
    type: String,
    default: "",
  },
  aspectRatio: {
    type: String,
    default: "",
  },
  countdownRight: {
    type: String,
    default: "4%",
  },
  countdownBottom: {
    type: String,
    default: "14.5%",
  },
  showDetailButton: {
    type: Boolean,
    default: false,
  },
},
  emits: ["change"],
  setup(__props, { expose, emit }) {
  expose();

const props = __props

_useCssVars(_ctx => ({
  "2b6d4c34-mainColor": (_unref(mainColor))
}))

const mainColor = process.env.VUE_APP_MAINCOLOR;


const router = useRouter();

const nowTime = ref(Date.now());
let countdownTimer: ReturnType<typeof setInterval> | undefined;
const countdownLabels = ["Hari", "Jam", "Menit", "Detik"];

const boxStyle = computed(() => ({
  padding: props.boxPadding,
  borderRadius: props.borderRadius,
  backgroundColor: props.backgroundColor || undefined,
  "--banner-border-radius": props.borderRadius,
  "--banner-image-fit": props.imageFit,
  "--countdown-right": props.countdownRight,
  "--countdown-bottom": props.countdownBottom,
}));

const swipeStyle = computed(() => {
  if (!props.aspectRatio) {
    return {};
  }
  return {
    aspectRatio: props.aspectRatio,
  };
});

onMounted(() => {
  countdownTimer = setInterval(() => {
    nowTime.value = Date.now();
  }, 1000);
});

onBeforeUnmount(() => {
  if (countdownTimer) {
    clearInterval(countdownTimer);
  }
});

const getImageUrl = (item) => {
  return item[props.imageField] || (props.fallbackImageField ? item[props.fallbackImageField] : "");
};

const getTitle = (item) => {
  return item[props.titleField] || item.banner_title || item.bannerTitle || "";
};

const parseEndTime = (endTime?: string | number) => {
  if (!endTime) {
    return 0;
  }

  if (typeof endTime === "number") {
    return endTime > 10000000000 ? endTime : endTime * 1000;
  }

  const endTimeText = String(endTime).trim();
  if (/^\d+$/.test(endTimeText)) {
    const timestamp = Number(endTimeText);
    return timestamp > 10000000000 ? timestamp : timestamp * 1000;
  }

  const match = endTimeText.match(/^(\d{4})-(\d{2})-(\d{2})(?:\s+|T)(\d{2}):(\d{2}):(\d{2})$/);
  if (match) {
    const [, year, month, day, hour, minute, second] = match;
    return new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second)
    ).getTime();
  }

  const timestamp = new Date(endTimeText).getTime();
  return isNaN(timestamp) ? 0 : timestamp;
};

const getCountdownSeconds = (item) => {
  if (String(item.is_countdown) !== "1") {
    return 0;
  }

  const endTimestamp = parseEndTime(item.end_time);
  if (!endTimestamp) {
    return 0;
  }

  return Math.max(0, Math.floor((endTimestamp - nowTime.value) / 1000));
};

const shouldShowCountdown = (item) => {
  return getCountdownSeconds(item) > 0;
};

const countdownItems = (item) => {
  const totalSeconds = getCountdownSeconds(item);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [days, hours, minutes, seconds].map((value, index) => ({
    value: String(value).padStart(2, "0"),
    label: countdownLabels[index],
  }));
};

const onChange = (index: number) => {
  emit("change", index, props.items[index]);
};

const getJumpValue = (item, snakeKey: string, camelKey: string) => {
  return item[snakeKey] === undefined || item[snakeKey] === null ? item[camelKey] : item[snakeKey];
};

const onClick = (item) => {
  const jumpType = Number(getJumpValue(item, "jump_type", "jumpType"));
  if (!jumpType) return;

  if (jumpType == 1) {
    const jumpUrl = getJumpValue(item, "jump_url", "jumpURL") || "";
    if (jumpUrl.startsWith("/")) {
      nativeToNewWeb(router, jumpUrl);
    } else if (jumpUrl) {
      toLocationBrowser(jumpUrl);
    }
  } else if (jumpType == 2 || jumpType == 3) {
    const roomId = getJumpValue(item, "jump_room_id", "jumpRoomID");
    const matchType = getJumpValue(item, "platform_type", "platformType") || getJumpValue(item, "type_id", "typeID");
    nativeToNewWeb(router, `/player?id=${roomId}&&matchType=${matchType}`)
  } else if (jumpType == 5) {
    const id = parseInt(String(getJumpValue(item, "type_id", "typeID")));
    const chatkey = IMUtils.createChatKey(id).toString();
    toMsgChat(router, id, chatkey);
  } else if (jumpType == 6) {
    nativeToNewWeb(router, `/invitef?a=b`)
  } else if (jumpType == 7) {
    nativeToNewWeb(router, `/activity?a=1`)
  } else if (jumpType == 8) {
    EventBus.emit("jumpIndex", getJumpValue(item, "jump_event_id", "jumpEventID"))
  } else if (jumpType == 9) {
    router.push("/match");
  }
};

const __returned__ = { mainColor, props, router, emit, nowTime, countdownTimer, countdownLabels, boxStyle, swipeStyle, getImageUrl, getTitle, parseEndTime, getCountdownSeconds, shouldShowCountdown, countdownItems, onChange, getJumpValue, onClick }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})